import { z } from 'zod';
export const updateUserCreditsSchema = z.object({
    userId: z.string().uuid(),
    aiCreditsLimit: z.number().int().min(0).nullable(),
});
export const updateUserAdminSchema = z.object({
    userId: z.string().uuid(),
    isAdmin: z.boolean(),
});
export const updateGlobalSettingsSchema = z.object({
    defaultAiCreditsLimit: z.number().int().min(1).max(10000),
});
export const adminUserFilterSchema = z.object({
    search: z.string().max(100).optional(),
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(20),
});
//# sourceMappingURL=admin.js.map